import { useCallback } from 'react'

import useConfiguration from './useConfiguration'
import { useStore } from '../state/client'

export default function useAddressData() {
  const { configuration } = useConfiguration()

  const addressData = useStore((state) => state.addressData)
  const loadAddress = useStore((state) => state.loadAddress)

  const fetchAddressData = useCallback(
    async (zipCode) => {
      if (!zipCode) {
        return
      }
      await loadAddress(zipCode, configuration?.extensions.fetchAddressDataMiddleware)
    },
    [configuration, loadAddress]
  )

  return {
    addressData,
    fetchAddressData,
  }
}
